<template>
  <div class="statPopoverTable">
    <table aria-label="Stat Popover Table">
      <thead>
        <tr>
          <th v-for="column in columns" :key="column"
            :scope="column"
          >
            {{ column }}
          </th>
        </tr>
      </thead>
      <tbody v-if="data.length > 0">
        <tr v-for="(row, index) in data" :key="index">
          <td v-for="(column, index) in row" :key="index">
            <div v-if="index === 0" class="statPopoverTable-labels" :style="labelsStyle">
              <div class="statPopoverTable-labels-colorBox" :style="{backgroundColor: row[0].color}"></div>
              <div>{{ column | nebFormat }}</div>
            </div>
            <template v-else>
              {{ column | nebFormat }}
            </template>
          </td>
        </tr>
      </tbody>
      <tbody v-else class="statPopoverTable-noData">
        <tr>
          <td :colspan="columns.length">
            <span>Sorry!</span>
            Not enough data to calculate.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {

  name: 'stat-popover-table',
  props: ['data', 'columns'],
  data () {
    return {

    }
  },
  computed: {
    labelsStyle () {
      // Find the length of the longest label
      const maxLabelLength = Math.max(...this.data.map(row => row[0].value.length))

      if (maxLabelLength <= 6) {
        return {
          maxWidth: '20ch',
          paddingRight: '154px'
        }
      }

      if (maxLabelLength <= 20) {
        return {
          maxWidth: '30ch',
          paddingRight: '70px'
        }
      }

      // Set the minimum width to 3/4 the length of the longest label to prevent excessive wrapping.
      const maxWidth = maxLabelLength * 0.75

      return {
        maxWidth: `${maxWidth}ch`,
        paddingRight: '0'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.statPopoverTable {
  max-height: 210px;
  overflow-y: scroll;

  &-noData {
    td {
      height: 110px;
      text-align: center !important;

      span {
        font-weight: bold;
        display: block;
      }
    }
  }

  table {
    border-collapse: collapse;
    min-width: 175px;
  }

  th, td {
    text-align: right;
    font-weight: normal;
    padding: 7px 5px;
    white-space: nowrap;

    &:first-of-type {
      text-align: left;
      white-space: initial;
      min-width: 135px;
    }
  }

  thead {
    font-size: 10px;
    color: #9b9b9b;
    text-transform: uppercase;
    border-bottom: solid 1px #cecece;

    th {
      padding-top: 0;
      padding-bottom: 6px;
    }
  }


  td {
    font-size: 12px;
    font-weight: bold;

    &:first-of-type {
      font-weight: normal;
      text-align: left;
    }
  }

  tbody {
    tr:first-of-type {
      td {
        padding-top: 9px;
      }
    }
  }
  &-labels {
    display: flex;
    white-space: normal;
    word-break: normal;

    &-colorBox {
      flex-shrink: 0;
      height: 12px;
      width: 12px;
      display: inline-block;
      margin-top: 2px;
      margin-right: 5px;
    }
  }


}
</style>
